import gql from 'graphql-tag';

import { EVENT_ACTIVITY_NOTE_FRAGMENT } from '../../fragments/eventActivityNote.fragment';

export const ADD_EVENT_NOTE = gql`
  mutation addEventNote($input: CreateDealEventActivityNoteInput!) {
    dealActivity {
      result: createDealEventActivityNote(input: $input) {
        error
        success
        entity {
          __typename
          ...DealEventActivityNoteFields
        }
      }
    }
  }
  ${EVENT_ACTIVITY_NOTE_FRAGMENT}
`;
